export default __webpack_public_path__ + "static/media/Ballroll_00173.a2bd1930.png";